import React, { useEffect } from "react";
import { Rept } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { mt } from "../../../../St/comps/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { colors, Container, makeStyles, TextField, Typography } from "@material-ui/core";
import { Height } from "@material-ui/icons";

export function Totals({ data }) {
  const cls = useRptAF();
  return (

    <Grid
      container
      lg={12}
      md={12}

      style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem", backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular" }}
    >
      <Grid container xs={12} /*className={cls.rootchip}*/ style={{
        paddingBottom: 5,
        backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
        border: "solid 1px",
        padding: "0.3rem 0.1rem 0.3rem 0.1rem",
        borderRadius: "0px 0px 5px 0px"
      }}>
        <Grid item xs={1} className={[cls.chipVMU]}></Grid>

        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totDept}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totCredit}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}></Grid>
        <Grid item xs={4} className={[cls.chipTMU]}>
          {"إجمالي الفترة المحددة"}
        </Grid>
      </Grid>
      <Grid container xs={12} /*className={cls.rootchip}*/
        style={{
          paddingBottom: "0.5rem", backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
          border: "solid 1px",
          padding: "0.2rem 0.1rem 0.2rem 0.1rem",
          borderRadius: "0px 0px 5px 0px",
        }}>
        <Grid item xs={1} className={[cls.chipVMU]}></Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totBlncDept}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totBlncCredit}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}></Grid>
        <Grid item xs={4} className={[cls.chipTMU]}>
          {"رصيد الفترة المحددة"}
        </Grid>
      </Grid>

    </Grid>
  );
}
function BodyA(props) {
  const { data, isFullPage, isLast, found } = props;
  const cls = useRptAF();
  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    border: "solid 0.1px",
    fontSize: "0.55rem",
    // width: "350px",
    maxWidth: "350px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: "الرصيد", field: "balance" },
    { title: "مدين", field: "dept" },
    { title: "دائن", field: "credit" },
    { title: "رقم المستند", field: "doc_no" },
    {
      title: "تاريخ المستند",
      field: "date",
      render: (expense) => reFormatDate(expense.date),
    },
    { title: "رقم المرجع", field: "ref_no" },
    {
      title: "البيان",
      field: "notes",
      cellStyle: cellS,
    },
  ];


  const data2 = data.map((row) => {
    return {
      ...row,
      balance: row.balance.toFixed(2),
      dept: row.dept.toFixed(2),
      credit: row.credit.toFixed(2),
    };
  });
  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}
        // style={{
        //   maxHeight: isFullPage ?   "59rem": "42.5rem",
        //   minHeight: isFullPage ?  "59rem": "42.5rem",
        // }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={data2}
          />
          {isLast && <Totals data={data ?? []} />}
        </Grid>

        {isLast && (
          // <Grid container xs={12}>
          //   <TextField fullWidth variant="outlined" size="small"
          //     id="refno"
          //     inputProps={{ borderColor: "black", color: 'red', fontWeight: "bold", fontSize: "0.9rem", fontFamily: "Amiri-Regular" }}
          //     type="text"
          //     name="notes"
          //     multiline
          //     value={found?.Disc4_footer_ar}
          //   />
          // </Grid>

          <Grid xs={12} style={{fontFamily: "Amiri-Regular",fontWeight:"bold"}} className={cls.infoF}>
            <div>{found?.MailBox}</div>
          </Grid>

        )}

        {/* <Grid item xs={12}>
        </Grid> */}
      </Grid>
      {/* <Grid container lg={12} md={12} style={{ direction: "rtl",paddingTop:"0.5rem"}}>
        <Grid container xs={12} className={cls.rootinfAcc}>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"المدير العام"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"المدير المالي"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"المراجع"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"المحاسب"}
          </Grid>
          <Grid item xs={4} className={[cls.infAcc]}>
            {"المستخدم"}
          </Grid>
        </Grid>
        <Grid container xs={12} className={[cls.rootinfAcc, cls.downinfAcc]}>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"--------------------"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"--------------------"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"--------------------"}
          </Grid>
          <Grid item xs={2} className={[cls.infAcc]}>
            {"--------------------"}
          </Grid>
          <Grid item xs={4} className={[cls.infAcc]}>
            {""}
          </Grid>
        </Grid>

      </Grid> */}

    </Grid>
  );
}

export default BodyA;
